// extracted by mini-css-extract-plugin
module.exports = {"Desc":"Subscription_Desc__1BwkK","Link":"Subscription_Link__YvPLv"};